import { GetTranslationsObj } from "types/types";
import { HeaderSubmenuItem } from "components/HeaderNew/HeaderFull/types";
import { MenuOpeningStatus } from "components/HeaderNew/HeaderFull";
import React, { useState } from "react";
import SubmenuButton from "components/HeaderNew/components/SubmenuButton";

type Props = {
  submenus: HeaderSubmenuItem[];
  currentSubmenu?: HeaderSubmenuItem;
  translations: GetTranslationsObj;
  onClick?: (value: MenuOpeningStatus) => void;
};

const SubmenuButtons = ({
  submenus,
  currentSubmenu,
  translations,
  onClick,
}: Props) => {
  // this state is usefull to check if at least one dropdown is opened
  // so it will be possibile to close during Tab navigation when another button is hovered
  const [isSomeDropdownOpen, setIsSomeDropdownOpen] = useState(false);

  return submenus.map((submenu) => (
    <SubmenuButton
      key={submenu.label}
      isActive={currentSubmenu?.label === submenu.label}
      aria-current={currentSubmenu?.label === submenu.label ? "page" : false}
      submenu={submenu}
      isSomeDropdownOpen={isSomeDropdownOpen}
      translations={translations}
      setIsSomeDropdownOpen={setIsSomeDropdownOpen}
      onClick={onClick}
    />
  ));
};

export default SubmenuButtons;
